import { render } from "./PartnerDell.vue?vue&type=template&id=b7ebacb6"
import script from "./PartnerDell.vue?vue&type=script&lang=js"
export * from "./PartnerDell.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__